import { AuthContextProps } from '../components/auth-context';
import { getData } from './core';

export default class TicketCommentsApi {
  static uri = 'n/accounts/TicketComments';
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  get(id: number) {
    return getData({
      uri: TicketCommentsApi.uri,
      id,
      context: this.context,
    });
  }
}
